import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { ErrorMessageSchema } from "@common/schemas/error.schema";

const c = initContract();

const completeInviteOnboardingBody = z
    .object({
        workspaceId: z.string().optional(),
        organizationId: z.string().optional(),
    })
    .refine(
        (data) => Boolean(data.workspaceId) || Boolean(data.organizationId),
        {
            message: "Either workspaceId or organizationId must be provided",
        },
    );

export const userOnboardingContract = c.router(
    {
        completeWorkspaceOnboarding: {
            method: "POST",
            path: "/workspace/:workspaceId",
            body: c.noBody(),
            responses: {
                204: c.noBody(),
                400: ErrorMessageSchema,
            },
        },
        completeOrganizationOnboarding: {
            method: "POST",
            path: "/organization/:organizationId",
            body: c.noBody(),
            responses: {
                204: c.noBody(),
                400: ErrorMessageSchema,
            },
        },
        completeInviteOnboarding: {
            method: "POST",
            path: "/invite",
            body: completeInviteOnboardingBody,
            responses: {
                204: c.noBody(),
            },
        },
    },
    {
        pathPrefix: "/user/onboarding",
    },
);
